import { render, staticRenderFns } from "./mobilenav.vue?vue&type=template&id=f43bb95c"
import script from "./mobilenav.vue?vue&type=script&lang=js"
export * from "./mobilenav.vue?vue&type=script&lang=js"
import style0 from "./mobilenav.vue?vue&type=style&index=0&id=f43bb95c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./mobilenav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports